import { AddressGet } from "../models/address-get";
import { State } from "../models/state";
import { ClassSchedule } from "../models/class-schedule";
import { ClassScheduleSession } from "../models/class-schedule-session";
import { Observable } from "rxjs";
import { Schedule } from "../models/schedule";
import { Setting } from "../models/settings";
import { Component, OnInit } from "@angular/core";
import { DataSharingService } from "../services/data-sharing.service";
import { UserService } from "../services/user.service";
import { ClassScheduleService } from "../services/class-schedule.service";
import { Location } from "../models/location";
import { StudentGet } from "../models/student-get";

@Component({
  selector: "app-select-location",
  templateUrl: "./select-location.component.html",
  styleUrls: ["./select-location.component.css"],
})
export class SelectLocationComponent implements OnInit {
  private _student: StudentGet = new StudentGet();

  constructor(
    private _dataService: DataSharingService,
    private _classService: ClassScheduleService,
    private _user: UserService
  ) {}

  locations: Location[] = [];
  allLocations: Location[] = [];
  loading = true;
  price = "0.00";
  classTypeId = "";
  className = "";
  isStudent: boolean = false;
  formattedName: string;
  searchFilter: string;

  seeMoreLocations() {
    alert("See More Locations Clicked");
  }

  ngOnInit() {
    // 8-hour initial class has ClassTypeId of 1, ClassDurationId of 1 or 2
    // 4-hour refresh class has ClassTypeId of 2, ClassDurationId of 3 or 4
    // (or can safely say, in either case ClassDurationId < 5)
    this.searchFilter = "";
    this.classTypeId = this._dataService.getClassTypeId();
    this.className =
      this.classTypeId === "1"
        ? "8-Hour Initial Course"
        : "4-Hour Course";
    const roleId = this._dataService.getRoleId();
    this.isStudent = roleId === this._user.roleStudent;

    var student = this._dataService.getCurrentStudent().student;
    let distanceType = this._dataService.getDistanceType();
    this.formattedName =
      student.firstName +
      " " +
      (student.middleName == null ? "" : student.middleName + " ") +
      student.lastName;
    this._classService
      .getLocations(this.classTypeId, student.id, distanceType)
      .subscribe(
        (res) => this.getLocationsSuccsess(res),
        (error) => this.getLocationsFailed(error),
        () => console.log("Get Locations Complete!")
      );
    this._dataService
      .getSetting(
        "Price",
        this.classTypeId === "1" ? "price8Hour" : "price4Hour"
      )
      .subscribe(
        (res) => this.getSettingSuccsess(res),
        (error) => this.getSettingFailure(error),
        () => console.log("Get Locations Complete!")
      );
  }

  getSettingSuccsess(result: any) {
    const setting = result[0] as Setting;
    this.price = setting.description;
  }
  getSettingFailure(error: any) {
    return "error";
  }

  getLocationsSuccsess(result: any) {
    let locations: Location[] = [];
    for (let i = 0, len = result.length; i < len; i++) {
      const loc = result[i] as Location;
      if (loc != null && loc.address != null) {
        if (loc.address.address2) {
          loc.address.formattedAddress = `${loc.address.address1}, ${loc.address.address2}, ${loc.address.city} ${loc.address.state.abbreviation} ${loc.address.zipCode}`;
        } else {
          loc.address.formattedAddress = `${loc.address.address1}, ${loc.address.city} ${loc.address.state.abbreviation} ${loc.address.zipCode}`;
        }
      } else {
        console.log(loc);
      }
      locations.push(loc);
    }
    this.loading = false;
    locations.sort(function (a, b) {
      return a.distanceToStudent - b.distanceToStudent;
    });

    this.locations = locations;
    this.allLocations = locations;
  }

  getLocationsFailed(error: any) {
    this.loading = false;
  }

  searchLocations() {
    let locations: Location[] = [];
    const searchFilter = this.searchFilter.toLowerCase();
    if (this.searchFilter <= " ") {
      locations = this.allLocations;
    } else {
      for (let i = 0; i < this.allLocations.length; i++) {
        const location = this.allLocations[i];
        if (location.address !== null) {
          if (
            location.address.zipCode.toLowerCase().indexOf(searchFilter) >= 0 ||
            location.address.city.toLowerCase().indexOf(searchFilter) >= 0
          ) {
            locations.push(location);
          }
        }
      }
    }
    this.locations = locations;
  }
}



// WEBPACK FOOTER //
// ./src/app/select-location/select-location.component.ts